<template>
  <div class="noticDialog">
    <!-- 公告详情 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="1150px"
      append-to-body
      center
    >
      <div v-html="content"></div>
      <div style="text-align:center">
        <img :src="imgUrl" alt="" style="width:90%;height:auto;">
      </div>
      <div class="timeWrap">
        <span>{{ time }}</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global http protocol*/
export default {
  name: 'NoticeDialog',
  data() {
    return {
      dialogVisible: false,
      currentclassifyId: 2,
      isCurrentId: this.$route.params.articleId,
      content: '',
      sign: '',
      title: '',
      time: '',
      imgUrl: '',

      ismore: '查看更多',
      selectnPage: window.sessionStorage.getItem('selectnPage'),
      param_getArticle: {}
    }
  },
  computed: {},
  watch: {},
  mounted() {
    // const currentTab = window.sessionStorage.getItem('selectnPage')
  },
  methods: {
    showDialog(id) {
      this.dialogVisible = true
      // this.getArticle(this.isCurrentId)
      this.getArticle(id)
    },
    gotoNotice() {
      this.$router.push('/myNotice/notice/noticelist')
    },

    gotoIndex() {
      this.$router.push('/index')
    },

    getArticle(id) {
      const that = this
      // const localeLanguage = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      this.param_getArticle = protocol.param_getContentDetails
      this.param_getArticle.param.id = id
      http.getRes(this.param_getArticle).then(response => {
        const { code, message, value } = response.data
        if (code == '0') {
          that.imgUrl = value.titleImg
          that.title = value.title
          that.content = value.content
          that.time = global.util.dateFormate(Number(value.updateTime))
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  background-color: #fff !important;
  border-radius: 8px;
  padding-left: 30px;
  padding-right: 30px;
  color: #000 !important;
  .el-dialog__header {
    span {
      font-size: 26px;
      font-weight: 600;
      color: #000 !important;
    }
  }
  .timeWrap {
    text-align: right;
    span {
      font-size: 20px;
      font-weight: 600;
      color: #000;
    }
  }
  p {
    font-size: 18px;
    font-weight: 600;
    color: #000 !important;
  }
}
/deep/ .el-dialog__title,
/deep/ .el-dialog__body {
  * {
    font-size: 18px;
    font-weight: 600;
    color: #000 !important;
  }
  img{
    width: 200px;
  }
}
/deep/ .el-dialog__header{
    padding-top: 30px;
}
</style>
